// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LabelBadge_wrapper__3Oodj"};